import { all, takeEvery, put, call } from 'redux-saga/effects';
import actions from './actions';
import { addData } from '../../helpers/fackBackend_Helper';

function* getActivationReportResponse({ payload: { searchData } }) {
    try {
        const response = yield call(addData, '/activationRequestReport', searchData);
        if (response.Status) {

            yield put(
                actions.getActivationReportSuccess(
                    response.activations
                ));
        } else {

            yield put(actions.getActivationReportFailed(response.response.Message));
        }
    } catch (error) {

        yield put(actions.getActivationReportFailed(error));
    }
}

function* getTypeCodeDataResponse({ payload: { data } }) {
    try {
        const response = yield call(addData, '/shortCode', data);
        if (response.response.Status) {
            yield put(actions.getTypeCodeSuccess(response.response.Data));
        } else {
            yield put(actions.getTypeodeFailed(response.response.Message));
        }
    } catch (error) {
        yield put(actions.getTypeodeFailed(error));
    }
}

export default function* rootSaga() {
    yield all([takeEvery(actions.GET_ACTIVATION_REPORT, getActivationReportResponse)]);
    yield all([takeEvery(actions.GET_TYPE_CODE, getTypeCodeDataResponse)]);
}